export default __webpack_public_path__ + "static/media/unlockBigIcon.2a36bd61.svg";